'use strict';

/**
* @ngdoc service
* @name tcApp.WebsysEditLegacyScope
* @description
* Contains systemUI equivalents for legacy functions originally defined in websys.edit.tools.js
*
*/
angular.module('tc.legacyScope').factory('WebsysEditLegacyScope', function($window, $log,
							LegacyScopeSearchService, LegacyScopeUtilsService, GlobalService) {
	
	/* eslint no-unused-vars:0 */
	return function($scope) {
		var emptyFunction = function() {
		};
		
		// Click handler that cancels click if link is disabled
		var linkDisable = function(event) {
			if ((event) && (event.target) &&
			((event.target.disabled) || (event.target.readOnly))) {
				return false;
			}
			return true;
		};
		
		var resetItemDirtyState = function(item, dirty) {
			var formItem = LegacyScopeUtilsService.getFormItem($scope, item.id);
			if (angular.isDefined(formItem)) {
				formItem.$validate();
				if (dirty) {
					formItem.$setDirty();
				} else if (formItem.$valid) {
					formItem.$setPristine();
				}
			}
		};
		
		// Sets an item as required
		var labelMandatory = function(keyOrItem) {
			var item = (angular.isString(keyOrItem) ? LegacyScopeSearchService.getItemFromDataObject($scope, keyOrItem, false)
						: keyOrItem);
			if (item) {
				item.required = true;
				if (item.displayType === 'T') resetItemDirtyState(item, (item.defaultValue !== item.value));
			}
		};
		
		// Sets an item as not required
		var labelNormal = function(keyOrItem) {
			var item = (angular.isString(keyOrItem) ? LegacyScopeSearchService.getItemFromDataObject($scope, keyOrItem, false)
						: keyOrItem);
			if (item) {
				item.required = false;
				if (item.displayType === 'T') resetItemDirtyState(item, (item.defaultValue !== item.value));
			}
		};
		
		// Checks if an item is required
		var isLabeledMandatory = function(key) {
			var item = LegacyScopeSearchService.getItemFromDataObject($scope, key, false);
			if ((item) && (angular.isDefined(item.required))) {
				return item.required;
			}
			return false;
		};
		
		// Internal function - used to set the state of all items or table items
		// Recursively sets state for all items on nested components
		var setStateForItems = function(items, state, excludeList, setAsReadOnly, clearValue, alwaysEnableFields,
								excludeLinks) {
			if (angular.isDefined(excludeList) && (excludeList !== '') && (angular.isString(excludeList))) {
				excludeList = excludeList.trim().split(',');
				excludeList = excludeList.filter(function(excludeItem) {
					return excludeItem != '';
				});
			}
			angular.forEach(items, function(item, key) {
				if ((key === 'elements') || (key.substr(0, 1) === '_') || (key.substr(0, 2) === '$$')) return;
				if (item.hiddenItem) return;
				if (excludeList) {
					if (angular.isDefined(item._listRowIndex)) {
						// Allow wildcard matching for table items
						if (excludeList.indexOf(key + '*') !== -1) return;
					} else {
						if (excludeList.indexOf(key) !== -1) return;
					}
				}
				if ((state === 'enabled') && (!alwaysEnableFields) && angular.isDefined($scope.viewModel.permanentlyDisabled)
					&& ($scope.viewModel.permanentlyDisabled.indexOf(',' + key + ',') !== -1)) return;
				
				if ((excludeLinks) && (item.displayType === 'A')) return;
				if (item.displayType === 'CX') {
					if ((item.componentData) && (item.componentData.componentName)) {
						if (angular.isDefined(item.componentData.items)) {
							// Recursive call
							setStateForItems(item.componentData.items, state, excludeList, setAsReadOnly, clearValue,
								alwaysEnableFields, excludeLinks);
						}
						if (angular.isDefined(item.componentData.listRows)) {
							angular.forEach(item.componentData.listRows, function(listRowData, listRowIndex) {
								// Recursive call
								setStateForItems(listRowData, state, excludeList, setAsReadOnly, clearValue,
									alwaysEnableFields, excludeLinks);
							});
						}
					}
				} else {
					if (state === 'disabled') {
						if ((setAsReadOnly == true) && (['A','B'].indexOf(item.displayType) === -1)) {
							readOnlyField(key, item);
						} else {
							disableField('', !clearValue, item);
						}
					} else if (state === 'enabled') {
						enableField('', item, clearValue);
					} else if (state === 'cleared') {
						clearField(item);
					}
				}
			});
		};
		
		// Clears the value of an item for any item type
		var clearField = function(item) {
			if (angular.isString(item)) item = LegacyScopeSearchService.getItemFromDataObject($scope, item, false);
			
			if (!item) return;
			if ((item.displayType === 'B') || (item.displayType === 'A')) return;
			
			if (item.displayType === 'C') {
				var originalValue = item.value;
				item.value = false;
				if ((originalValue)
				&& (angular.isDefined(item.eventListeners)) && (angular.isDefined(item.eventListeners['click']))) {
					angular.forEach(item.eventListeners['click'], function(handler) {
						handler(item);
					});
				}
			} else if (item.displayType === 'L') {
				item.options = [];
				item.input = '';
			} else if ((item.displayType === 'HRT') || ((item.displayType === 'HTB') && !item.displayOnly)) {
				LegacyScopeUtilsService.runOnEditorReady($scope, item.id, function clearOnEditorReady(editor) {
					editor.setData('');
				});
			} else if (item.displayType === 'V') {
				$scope.clearSvgAnnotation(undefined, item.id);
			} else {
				item.value = '';
				if (item.displayType === 'T') resetItemDirtyState(item, (item.defaultValue !== ''));
			}
		};

		// Enables an item
		var enableField = function(key, item, clearValue) {
			if (!item) item = LegacyScopeSearchService.getItemFromDataObject($scope, key, true);
			if (item) {
				if (item.isSelectItem) {
					// ALlow enable of select checkbox
					if ((angular.isDefined($scope.data.listRows))
						&& (angular.isDefined($scope.data.listRows[item._listRowIndex]))) {
						$scope.data.listRows[item._listRowIndex]['_selectDisabled'] = false;
					}
				} else {
					// Don't allow enabling links with a Display Only conditional expression
					if ((item.displayType === 'A') && (item.displayOnly)) return;
					item.disabled = false;
					if (clearValue) clearField(item);
				}
			}
		};
		
		// Enables all items for a component
		var enableAllFields = function(excludeList, clearValue, unused1, unused2, alwaysEnableFields) {
			if (angular.isDefined($scope.data.items)) {
				setStateForItems($scope.data.items, 'enabled', excludeList, false, clearValue, alwaysEnableFields);
			}
			if (angular.isDefined($scope.data.listRows)) {
				angular.forEach($scope.data.listRows, function(listRowData, listRowIndex) {
					setStateForItems(listRowData, 'enabled', excludeList, false, clearValue, alwaysEnableFields);
				});
			}
		};
		
		// Disables an item
		var disableField = function(key, doNotClear, item) {
			if (!item) item = LegacyScopeSearchService.getItemFromDataObject($scope, key, true);
			if (item) {
				if (item.isSelectItem) {
					// Allow disable of select checkbox
					if ((angular.isDefined($scope.data.listRows))
						&& (angular.isDefined($scope.data.listRows[item._listRowIndex]))) {
						$scope.data.listRows[item._listRowIndex]['_selectDisabled'] = true;
						$scope.data.listRows[item._listRowIndex]['_selected'] = false;
						
						if ($scope.viewModel.listSettings.selectMode) {
							var currentPage = ($scope.data.listData.pageCount - 1);
							$scope.viewModel.listSettings.selectedRows[currentPage][item._listRowIndex] = false;
							$scope.selectRowHandler(null, false , $scope.data.listRows[item._listRowIndex]);
						}
					}
				} else {
					item.disabled = true;
					if ((doNotClear != 1) && (doNotClear != true)) {
						clearField(item);
						LegacyScopeUtilsService.setInputValidity($scope, item, 'invalid', true);
					}
				}
			}
		};
		
		// Disables all items
		var disableAllFields = function(unused1, excludeList, clearValue, unused2, unused3, unused4, setAsReadOnly,
								excludeLinks) {
			if (angular.isDefined($scope.data.items)) {
				setStateForItems($scope.data.items, 'disabled', excludeList, setAsReadOnly, clearValue, false, excludeLinks);
			}
			if (angular.isDefined($scope.data.listRows)) {
				angular.forEach($scope.data.listRows, function(listRowData, listRowIndex) {
					setStateForItems(listRowData, 'disabled', excludeList, setAsReadOnly, clearValue, false, excludeLinks);
				});
			}
		};
		
		// Sets an item as read only
		var readOnlyField = function(key, item) {
			if (!item) item = LegacyScopeSearchService.getItemFromDataObject($scope, key, false);
			if (!item) return;
			item.readOnly = true;
		};
		
		// Sets an item as not read only
		var undoReadOnlyField = function(key, item) {
			if (!item) item = LegacyScopeSearchService.getItemFromDataObject($scope, key, false);
			if (!item) return;
			item.readOnly = false;
		};
		
		// Clears the permanently disabled field list
		var clearPermanentlyDisabledFieldList = function() {
			$scope.viewModel.permanentlyDisabled = '';
		};
		
		// Sets the permanently disabled field list
		var setPermanentlyDisabledFieldList = function(items) {
			$scope.viewModel.permanentlyDisabled = items;
		};
		
		// Adds to the permanently disabled field list
		var addToPermanentlyDisabledFieldList = function(item) {
			if ((angular.isDefined($scope.viewModel.permanentlyDisabled)) &&
			($scope.viewModel.permanentlyDisabled !== '')) {
				$scope.viewModel.permanentlyDisabled += (item + ',');
			} else {
				$scope.viewModel.permanentlyDisabled = (',' + item + ',');
			}
		};
		
		var isEmail = function(event, obj) {
			if (!obj) obj = event;
			if (!obj) return;
			var regexEmail = /^.+@.+\..+$/;
			var SpacesExist=0;
			var val=obj.value;
			if (val !== '') {
				var lu=val.split(' ');
				if (lu.length!=1) SpacesExist=1;
				if (!(regexEmail.test(obj.value))||(SpacesExist)) {
					$scope.componentForm[$scope.componentHtmlName][obj.id].$setValidity('invalid', false);
					return false;
				}
			}
			$scope.componentForm[$scope.componentHtmlName][obj.id].$setValidity('invalid', true);
			return true;
		};
		
		// check Interval data format.
		// input example 1D 2H 3Min 3s (according to the standard type items)
		// type: 1.integer 2.numeric
		var checkIntervalFormat = function(objStr, ObjStandardTypeStr, type)	{
			// A blank string is a valid interval
			if (objStr == '') return true;
			var arr1 = objStr.split(' ');
			var arr2 = ObjStandardTypeStr.split('^');
			var rgx1 = /\d+/g;
			var rgx2 = /\d*\.?\d+/g;
			var rgx = '';
			var subStr = '';
			var subStrArr = new Array();
			var collectionArr = new Array();
			var res = 1;
			var find = 0;
			if (type == 1) rgx = rgx1;
			if (type == 2) rgx = rgx2;
			for (var i = 0; i < arr1.length; i++) {
				subStr = arr1[i].replace(rgx, '^');
				subStrArr = subStr.split('^');
				if (subStrArr.length != 2) return false;
				if ((i == arr1.length - 1) && (subStrArr[1] == '')) return true;
				find = 0;
				for (var j = 0; j < arr2.length; j++) {
					if (subStrArr[1].toUpperCase() == arr2[j].toUpperCase()) {
						if (collectionArr[j] == 1) {
							res = 0;
						} else {
							collectionArr[j] = 1;
							find = 1;
						}
					} else {
						continue;
					}

					if (res == 0) return false;
				}
				if (find == 0) return false;
			}
			return true;
		};
		
		var enableDisableByOwner = function() {
			$log.warn($scope.componentName, 'Call to EnableDisableByOwner');
		};
		
		var isRequireLock = function() {
			$log.warn($scope.componentName, 'Call to isRequireLock');
			return true;
		};
		
		// This one is now generic
		var checkMandatoryOrInvalidFields = function() {
			return '';
		};
		
		// Clears values for all items, and optionally list row items when 'clearListRowItems' is passed
		var clearAllFields = function(event, clearListRowItems, excludeList) {
			if (angular.isDefined($scope.data.items)) {
				setStateForItems($scope.data.items, 'cleared', excludeList);
			}
			if (clearListRowItems) {
				if (angular.isDefined($scope.data.listRows)) {
					angular.forEach($scope.data.listRows, function(listRowData, listRowIndex) {
						setStateForItems(listRowData, 'cleared', excludeList);
					});
				}
			} 
		};
		
		// Toggles visibility of an item
		var websysEditToggleField = function(key, obj, clearValue, visibilityHidden) {
			var hiddenState = false;
			if ((visibilityHidden === true) || (visibilityHidden == 'hidden') || (visibilityHidden == 'none')) {
				hiddenState = true;
			}
			if (!obj) obj = LegacyScopeSearchService.getItemFromDataObject($scope, key, true);
			if (!obj) {
				// Ignore warning for lookup icons
				if (/ld\d+i.+/g.test(key)) return;
				return;
			}
			// Support hiding table rows
			if (angular.isDefined(obj.cells)) {
				$scope.data.listRows[obj._listRowIndex]._hidden = hiddenState;
			} else {
				obj.hidden = hiddenState;
			}
			if (clearValue) {
				clearField(obj);
				if ((angular.isDefined($scope.componentForm[$scope.componentHtmlName]))
					&& (angular.isDefined($scope.componentForm[$scope.componentHtmlName][obj.id]))) {
					$scope.componentForm[$scope.componentHtmlName][obj.id].$setValidity('invalid', true);
					$scope.componentForm[$scope.componentHtmlName][obj.id].$setValidity('time', true);
					$scope.componentForm[$scope.componentHtmlName][obj.id].$setValidity('date', true);
					$scope.componentForm[$scope.componentHtmlName][obj.id].$setValidity('number', true);
				}
			}
			
			// When hiding/showing a button within the button bar, show/hide the button bar itself based on all items
			if (obj.isInButtonBar) {
				var showButtonBar = false;
				angular.forEach($scope.data.items, function(item) {
					if (item && item.isInButtonbar && !item.hidden) showButtonBar = true;
				});
				GlobalService.updateButtonBar(showButtonBar);
			}
			
			// Manually trigger Tab control or Dynamic Columns to resize/re-render
			if (!obj.hidden && (['TAB','CX'].indexOf(obj.displayType) !== -1)) {
				GlobalService.triggerWindowResize();
			}
		};
		
		// Hides an item
		var websysEditHideField = function(key, obj, clearValue) {
			websysEditToggleField(key, obj, clearValue, true);
		};
		
		// Shows an item
		var websysEditShowField = function(key, obj) {
			websysEditToggleField(key, obj, false, false);
		};
		
		// Removes or Restores lookup to textbox
		var websysEditToggleLookup = function(key, disabled) {
			if (/ld\d+i.+/g.test(key)) {
				key = key.split(/ld\d+i/)[1];	
			} else if ((/lt\d+i.+/g.test(key))) {
				key = key.split(/lt\d+i/)[1];
			}
			var obj = LegacyScopeSearchService.getItemFromDataObject($scope, key, false);
			if (angular.isObject(obj)) {
				obj.lookupDisabled = disabled;
				$scope.$broadcast('tcLookupContainer:toggleLookupDisabled', obj, disabled);
			}
		};
		
		// Removes lookup from textbox making it free text field
		var websysEditRemoveLookup = function(key) {
			websysEditToggleLookup(key, true);
		};
		
		// Restores lookup that has been removed or disabled via Lookup CondExpr
		var websysEditRestoreLookup = function(key) {
			websysEditToggleLookup(key, false);
		};
			
		// Return all the functions in an object
		var websysEditFunctions = {
			'LinkDisable': linkDisable,
			'labelMandatory': labelMandatory,
			'MandatoryField': labelMandatory,
			'labelNormal': labelNormal,
			'UndoMandatoryField': labelNormal,
			'isLabeledMandatory': isLabeledMandatory,
			'isMandatoryField': isLabeledMandatory,
			'ClearField': clearField,
			'EnableField': enableField,
			'EnableAllFields': enableAllFields,
			'DisableField': disableField,
			'DisableAllFields': disableAllFields,
			'ReadOnlyField': readOnlyField,
			'UndoReadOnlyField': undoReadOnlyField,
			'ClearPermanentlyDisabledFieldList': clearPermanentlyDisabledFieldList,
			'SetPermanentlyDisabledFieldList': setPermanentlyDisabledFieldList,
			'AddToPermanentlyDisabledFieldList': addToPermanentlyDisabledFieldList,
			'isEmail': isEmail,
			'CheckIntervalFormat': checkIntervalFormat,
			'ClearAll': clearAllFields,
			'websysEdit_HideField': websysEditHideField,
			'websysEdit_ShowField': websysEditShowField,
			'websysEdit_ToggleField': websysEditToggleField,
			'websysEdit_DisplayOff': websysEditHideField,
			'websysEdit_DisplayOn': websysEditShowField,
			'websysEdit_ToggleDisplay': websysEditToggleField,
			'websysEdit_RemoveLookup': websysEditRemoveLookup,
			'websysEdit_RestoreLookup': websysEditRestoreLookup,
			'websysEdit_ClearField': clearField,
			
			/* Not implemented */
			'DisableShortcutKey': emptyFunction,
			'ReEnableShortcutKey': emptyFunction,
			'DisableLookup': emptyFunction,
			'EnableLookup': emptyFunction,
			'ForceChange': emptyFunction,
			'EnableDisableByOwner': enableDisableByOwner,
			'CheckMandatoryOrInvalidFields': checkMandatoryOrInvalidFields,
			'isRequireLock': isRequireLock,
			'AddColsHeadOverrideIndicators': emptyFunction,
			'AddOverrideIndicators': emptyFunction,
			'DisableListRows': emptyFunction
		};

		return websysEditFunctions;
	};
});
